import { ApplicationType } from "interfaces/models/ApplicationType";
import { ApplicationTypeDisplay } from "interfaces/models/ApplicationTypeDisplay";
import { InputHTMLAttributes } from "react";
import { Accordion, Form } from "react-bootstrap";

interface ApplicationTypesFilterProps extends InputHTMLAttributes<HTMLInputElement> {
  register: any;
  accordionKey: string;
  applicationTypes: ApplicationType[];
  hasFilterChanged : boolean;
  handleOnChange? : () => void;
}

const ApplicationTypesFilter : React.FC<ApplicationTypesFilterProps> = ({
  register, accordionKey, applicationTypes, hasFilterChanged, handleOnChange
} : ApplicationTypesFilterProps) => {
  const renderApplicationTypes = () => applicationTypes.map(applicationType => (
    <Form.Check
      {...register("applicationType")}
      key={`applicationType_${applicationType}`}
      id={`applicationType_${applicationType}`}
      data-testid={`applicationType_${applicationType}`}
      name="applicationType"
      type="checkbox"
      label={ApplicationTypeDisplay[applicationType]}
      value={applicationType}
      className="left-margin-medium"
      onInput={handleOnChange}
    />
  ));

  return (
    <Accordion key={accordionKey} defaultActiveKey={hasFilterChanged ? "accordionApplications" : ""}>
      <Accordion.Item eventKey="accordionApplications">
        <Accordion.Header data-testid="header">
          System
        </Accordion.Header>
        <Accordion.Body>
          <section>
            <Form.Group controlId="applicationTypes">
              {renderApplicationTypes()}
            </Form.Group>
          </section>

        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ApplicationTypesFilter;
